import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    modalContainer: {
        backgroundColor: "rgba(0,0,0,0.5)",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
        flex: 1
    },
    infoText: {
        marginBottom: 15
    },
    infoCard: {
        borderWidth: 1
    },
    modalContent: {
        width: "100%",
        maxWidth: 400,
        padding: 20
    },
    fullWidth: {
        width: "100%"
    }
});
export default stylesheet;
